"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgXMark = function SvgXMark(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.362 2.617a.996.996 0 0 0-.822-.053 1.897 1.897 0 0 0-.665.428A449.745 449.745 0 0 0 12 9.7a449.578 449.578 0 0 0-6.875-6.708 1.896 1.896 0 0 0-.665-.428.996.996 0 0 0-.822.053 2.532 2.532 0 0 0-.578.443c-.204.204-.346.4-.443.578a.996.996 0 0 0-.053.822c.087.251.251.479.428.665A449.252 449.252 0 0 0 9.7 12a449.419 449.419 0 0 0-6.708 6.875 1.896 1.896 0 0 0-.428.665.996.996 0 0 0 .053.822c.097.179.239.374.443.578.204.204.4.346.578.443.277.15.565.142.822.053.251-.087.479-.251.665-.428A449.366 449.366 0 0 0 12 14.3a449.003 449.003 0 0 0 6.875 6.708c.186.177.414.341.665.428a.996.996 0 0 0 .822-.053 2.54 2.54 0 0 0 .578-.443c.204-.204.346-.4.443-.578a.996.996 0 0 0 .053-.822 1.894 1.894 0 0 0-.428-.665A448.666 448.666 0 0 0 14.3 12a449.068 449.068 0 0 0 6.708-6.875c.177-.186.341-.414.428-.665a.997.997 0 0 0-.053-.822 2.533 2.533 0 0 0-.443-.578 2.532 2.532 0 0 0-.578-.443Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgXMark);
var _default = exports["default"] = Memo;